module.exports = __webpack_public_path__ + "static/img/de.a3be1b5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/client/logo/de.jpg
// module id = tRLN
// module chunks = 0